export const chartDefaultColors = ["#36A2EB", "#FFCE56", "#FF6384", "#E5E5E5"];